import { render, staticRenderFns } from "./organizations-details.html?vue&type=template&id=28153b34&scoped=true&external"
import script from "./organizations-details.js?vue&type=script&lang=js&external"
export * from "./organizations-details.js?vue&type=script&lang=js&external"
import style0 from "./organizations-details.scss?vue&type=style&index=0&id=28153b34&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28153b34",
  null
  
)

export default component.exports